import styled from 'styled-components';
import LXStyledButton from './core';

const LXLargeButton = styled(LXStyledButton)`
  height: var(--bt-lg-height);
  padding: var(--bt-lg-padding);
`;

export default LXLargeButton;
